import React, { useEffect,useState, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/states/statesActions";
import * as crud from "../../../_redux/states/statesCrud";

import * as uiHelpers from "../StatesUIHelpers";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { getRowStyleByStatus } from "../../../_helpers/tableRowStatusColors";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useStatesUIContext } from "../StatesUIContext";

export function StatesTable() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }

  // States UI Context
  const statesUIContext = useStatesUIContext();
  const statesUIProps = useMemo(() => {
    return {
      ids: statesUIContext.ids,
      setIds: statesUIContext.setIds,
      queryParams: statesUIContext.queryParams,
      setQueryParams: statesUIContext.setQueryParams,
      openEditStatePage: statesUIContext.openEditStatePage,
      openDeleteStateDialog: statesUIContext.openDeleteStateDialog,
    };
  }, [statesUIContext]);

  // Getting curret state of states list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.states }),
    shallowEqual
  );

  const delay = ms => new Promise(res => setTimeout(res, ms));

  const { totalCount, entities, listLoading } = currentState;
  const [processing, setProcessing] = useState('');
  const [isEdit, setisEdit] = useState('');
  const [nameValue, setNameValue] = useState('');

  // States Redux state
  const dispatch = useDispatch();

  const updateStatus = async (id, status) => {
    setProcessing(id);
    await crud.updateStatusForState(id, status);
    dispatch(actions.fetchStates(statesUIProps.queryParams));
    setProcessing('');
  };
  const isApprovalTab = ["approved", "pending", "rejected"].includes(window.location.pathname.split("/")[2]);
  const rowStyle = (row) => getRowStyleByStatus(row, isApprovalTab ? 'approval_status' : 'status');

  const editState = async (row) => {
    setisEdit(row.id);
    setNameValue(row.name);
  };
  
  const saveState = async (row) => {
    setProcessing("save" + row.id);
    await crud.updateRecordForState(row.id, nameValue);
    dispatch(actions.fetchStates(statesUIProps.queryParams));
    setisEdit('');
    setProcessing('');
  };

  useEffect(() => {
    // clear selections list
    statesUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchStates(statesUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statesUIProps.queryParams, dispatch]);
  // Table columns
  let columns = [
    {
      attrs: { title: 'Name' },
      dataField: "name",
      text: "Name",
      formatter: columnFormatters.NameColumnFormatter,
      formatExtraData: {
        isEdit: isEdit,
        setNameValue: setNameValue,
        nameValue: nameValue,
      },
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'Country' },
      dataField: "country.name",
      text: "Country",
      formatter: (cell, row) => row.country ? row.country.name : '',
      sort: true,
    },
    {
      attrs: { title: 'Status' },
      dataField: "status",
      text: "Status",
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        updateStatus: updateStatus,
        superadmin: superadmin,
        processing: processing,
      },
      sort: true,
      sortCaret: sortCaret,
    },
  ];
  if(superadmin)
  {
    columns.push({
      attrs: { title: 'Actions' },
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        editState:editState,
        saveState:saveState,
        isEdit:isEdit,
        processing:processing,
        setisEdit:setisEdit,
      },
      
      style: {
        minWidth: "100px",
      },
    })
  }
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: statesUIProps.queryParams.pageSize,
    page: statesUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="custom-res-table table table-head-custom table-head-bg table-vertical-center"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                rowStyle={ rowStyle } 
                onTableChange={getHandlerTableChange(
                  statesUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: statesUIProps.ids,
                  setIds: statesUIProps.setIds,
                })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
